import { render, staticRenderFns } from "./LimitForm.vue?vue&type=template&id=171a2b6e"
import script from "./LimitForm.vue?vue&type=script&lang=js"
export * from "./LimitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports